<template>
  <div class="role box">
    <div class="box-left">
      <div class="left-top">
        <span class="f-w-b">404</span>
        <div>需要访问的页面不存在！</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'error404',
  data() {
    return {};
  },
  mounted() {
    window.$this = this;
  },
  methods: {}
};
</script>
<style scoped></style>
